export default {
  main: '#b1040e',
  mainLight: '#b81d26',
  mainDark: '#8d030b',
  white: '#fff',
  offWhite: '#fafdfe',
  shade: '#f9f9f9',
  lightGray: 'rgba(232, 232, 232, 0.6)',
  gray: '#bababc',
  darkGray: '#505153',
  black: '#25262c',
  highlight: '#eef7fe',
  background: '#e5e8ec',
  green: '#0f8048',
  success: '#13a55c',
  successAlt: '#16b867',
  lightGreen: '#eef9f4',
  red: '#cf2310',
  error: '#E62712',
  errorAlt: '#ed3f3f',
  lightRed: '#ffeeec',
  warn: '#FDD835',
  lightYellow: '#FFFDE7',
  xdHighlightDark: '#2367a8',
  xdHighlight: '#2c81d2',
  xdHighlightAlt: '#569adb',
  xdDarkBlue: '#445461',
  xdFadedBlue: '#BCC7D0',
  lightBlue: '#e9f2fa',
  instances: {
    uab: {
      main: 'rgb(62,129,104)',
      mainLight: 'rgb(101,154,134)',
      mainDark: 'rgb(7,94,66)'
    },
    lifespan: {
      main: 'rgb(255, 102, 68)',
      secondary: 'rgb(51, 133, 140)',
      mainLight: 'rgb(255,138,111)',
      mainDark: 'rgb(216,71,39)',
    },
    stanford: {
      main: 'rgb(177, 4, 14)',
      mainLight: '#b81d26',
      mainDark: '#8d030b',
    }
  }
};
